<!-- ── Admin top bar ─────────────────────────────────────────────────────── -->
<div style="background:#0f172a;color:#f8fafc;padding:0;position:sticky;top:0;z-index:100;box-shadow:0 1px 3px rgba(0,0,0,.4);">
  <div style="display:flex;align-items:center;justify-content:space-between;height:52px;padding:0 16px;max-width:1400px;margin:0 auto;">

    <!-- Nav links — horizontal scroll on mobile -->
    <div style="display:flex;align-items:center;gap:4px;overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none;flex:1;min-width:0;">
      <span style="font-size:13px;font-weight:700;letter-spacing:1px;color:#38bdf8;text-transform:uppercase;white-space:nowrap;flex-shrink:0;margin-right:8px;">TG Admin</span>
      <span style="width:1px;height:18px;background:#334155;flex-shrink:0;margin-right:4px;"></span>
      <a (click)="navigate('/admin/scraper')" style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;" onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Scraper</a>
      <a (click)="navigate('/admin/vacantes')" style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;" onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Vacantes</a>
      <span style="font-size:13px;font-weight:600;color:#f8fafc;padding:6px 10px;background:#1e3a5f;border-radius:4px;white-space:nowrap;flex-shrink:0;">Usuarios</span>
      <a routerLink="/admin/gurumatch"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">GuruMatch</a>
      <a routerLink="/admin/suscripciones" style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;" onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Suscripciones</a>
      <a (click)="navigate('/admin/config')" style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;" onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Config</a>
      <a routerLink="/admin/social" style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;" onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Redes Sociales</a>
    </div>

    <!-- Action buttons — always visible -->
    <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;margin-left:8px;">
      <span style="font-size:12px;color:#64748b;white-space:nowrap;">{{ total }} usuarios</span>
      <button (click)="exportarExcel()" [disabled]="exportando"
              style="display:inline-flex;align-items:center;gap:5px;background:#166534;color:#bbf7d0;border:none;border-radius:6px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;opacity:1;"
              [style.opacity]="exportando ? '0.6' : '1'">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:13px;height:13px;flex-shrink:0;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"/>
        </svg>
        {{ exportando ? 'Generando…' : 'Exportar Excel' }}
      </button>
      <button (click)="abrirModalCorreo()" [disabled]="selectedCount === 0"
              [style.background]="selectedCount > 0 ? '#1e40af' : '#1e293b'"
              [style.color]="selectedCount > 0 ? '#bfdbfe' : '#64748b'"
              [style.cursor]="selectedCount > 0 ? 'pointer' : 'not-allowed'"
              style="display:inline-flex;align-items:center;gap:5px;border:none;border-radius:6px;padding:6px 12px;font-size:12px;font-weight:600;white-space:nowrap;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:13px;height:13px;flex-shrink:0;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"/>
        </svg>
        Enviar Correo{{ selectedCount > 0 ? ' (' + selectedCount + ')' : '' }}
      </button>
      <button (click)="cerrarSesion()"
              style="display:inline-flex;align-items:center;gap:5px;background:#7f1d1d;color:#fca5a5;border:none;border-radius:6px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:13px;height:13px;flex-shrink:0;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"/>
        </svg>
        Salir
      </button>
    </div>
  </div>
</div>

<!-- ── Filters ────────────────────────────────────────────────────────────── -->
<div style="background:#1e293b;padding:14px 0;border-bottom:1px solid #334155;">
  <div class="tg-container">
    <div style="display:flex;flex-wrap:wrap;gap:8px;align-items:center;">

      <input [(ngModel)]="filtros.buscar" (input)="onTexto()" placeholder="Buscar por nombre, correo…"
             style="background:#0f172a;border:1px solid #334155;border-radius:6px;color:#f8fafc;padding:6px 10px;font-size:12px;min-width:220px;outline:none;">

      <select [(ngModel)]="filtros.tipo" (change)="onFiltro()"
              style="background:#0f172a;border:1px solid #334155;border-radius:6px;color:#f8fafc;padding:6px 10px;font-size:12px;outline:none;">
        <option value="ALL">Todos los tipos</option>
        <option value="CANDIDATO">Candidatos</option>
        <option value="EMPRESA">Empresas</option>
      </select>

      <select [(ngModel)]="filtros.authProvider" (change)="onFiltro()"
              style="background:#0f172a;border:1px solid #334155;border-radius:6px;color:#f8fafc;padding:6px 10px;font-size:12px;outline:none;">
        <option value="">Todos los accesos</option>
        <option value="local">Email/Contraseña</option>
        <option value="google">Google</option>
        <option value="linkedin">LinkedIn</option>
      </select>

      <select [(ngModel)]="filtros.activo" (change)="onFiltro()"
              style="background:#0f172a;border:1px solid #334155;border-radius:6px;color:#f8fafc;padding:6px 10px;font-size:12px;outline:none;">
        <option value="">Todos los estados</option>
        <option value="true">Activos</option>
        <option value="false">Bloqueados</option>
      </select>

      <button (click)="soloDuplicados = !soloDuplicados"
              [style.background]="soloDuplicados ? '#dc2626' : '#7f1d1d'"
              [style.color]="soloDuplicados ? '#fff' : '#fca5a5'"
              [style.borderColor]="soloDuplicados ? '#dc2626' : '#991b1b'"
              style="border:1px solid;border-radius:6px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;display:inline-flex;align-items:center;gap:5px;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:13px;height:13px;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
        </svg>
        {{ soloDuplicados ? 'Ver todos' : 'Solo duplicados' }}
      </button>

    </div>
  </div>
</div>

<!-- ── Table ──────────────────────────────────────────────────────────────── -->
<div class="tg-container" style="padding-top:24px;padding-bottom:40px;">

  <div *ngIf="cargando" style="text-align:center;padding:60px 0;color:#64748b;font-size:14px;">
    Cargando…
  </div>

  <div *ngIf="!cargando">

    <!-- Banner de duplicados -->
    <div *ngIf="hasDuplicados && !soloDuplicados"
         style="background:#fee2e2;border:1px solid #fca5a5;border-radius:8px;padding:10px 16px;margin-bottom:16px;display:flex;align-items:center;gap:10px;">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#dc2626" style="width:18px;height:18px;flex-shrink:0;">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
      </svg>
      <span style="font-size:13px;color:#991b1b;font-weight:600;">
        Hay correos registrados más de una vez. Los registros duplicados aparecen al inicio marcados en rojo.
        <button (click)="soloDuplicados = true" style="background:none;border:none;color:#dc2626;text-decoration:underline;cursor:pointer;font-size:13px;font-weight:700;padding:0 4px;">Ver solo duplicados</button>
      </span>
    </div>

    <div style="overflow-x:auto;border-radius:10px;border:1px solid #e2e8f0;box-shadow:0 1px 4px rgba(0,0,0,.06);">
      <table style="width:100%;border-collapse:collapse;background:#fff;font-size:12px;min-width:820px;">
        <thead>
          <tr style="background:#f8fafc;border-bottom:2px solid #e2e8f0;">
            <th style="padding:8px 6px;text-align:center;width:36px;">
              <input type="checkbox"
                     [checked]="selectedCount === candidatosEnviables.length && candidatosEnviables.length > 0"
                     (change)="$event.target.checked ? selectAll() : deselectAll()"
                     style="cursor:pointer;accent-color:#1d4ed8;width:14px;height:14px;">
            </th>
            <th (click)="sort('tipo')" style="padding:8px 10px;text-align:left;color:#475569;font-weight:600;white-space:nowrap;cursor:pointer;user-select:none;width:90px;">Tipo {{sortIcon('tipo')}}</th>
            <th (click)="sort('nombre')" style="padding:8px 10px;text-align:left;color:#475569;font-weight:600;cursor:pointer;user-select:none;">Nombre / Correo {{sortIcon('nombre')}}</th>
            <th (click)="sort('authProvider')" style="padding:8px 10px;text-align:left;color:#475569;font-weight:600;white-space:nowrap;cursor:pointer;user-select:none;width:90px;">Acceso {{sortIcon('authProvider')}}</th>
            <th (click)="sort('subscriptionStatus')" style="padding:8px 10px;text-align:center;color:#475569;font-weight:600;white-space:nowrap;cursor:pointer;user-select:none;width:80px;">Plan {{sortIcon('subscriptionStatus')}}</th>
            <th (click)="sort('createdAt')" style="padding:8px 10px;text-align:left;color:#475569;font-weight:600;white-space:nowrap;cursor:pointer;user-select:none;width:100px;">Registro {{sortIcon('createdAt')}}</th>
            <th (click)="sort('activo')" style="padding:8px 10px;text-align:center;color:#475569;font-weight:600;white-space:nowrap;cursor:pointer;user-select:none;width:88px;">Estado {{sortIcon('activo')}}</th>
            <th style="padding:8px 10px;text-align:center;color:#475569;font-weight:600;white-space:nowrap;width:90px;">Usos IA</th>
            <th style="padding:8px 10px;text-align:left;color:#475569;font-weight:600;white-space:nowrap;width:180px;">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of usuariosFiltrados"
              [style.background]="u.duplicado ? '#fff1f2' : (isSelected(u) ? '#eff6ff' : (u.activo ? '#fff' : '#fff7f7'))"
              [style.borderLeft]="u.duplicado ? '3px solid #dc2626' : (isSelected(u) ? '3px solid #1d4ed8' : '3px solid transparent')"
              style="border-bottom:1px solid #f1f5f9;transition:background .15s;">

            <!-- Checkbox -->
            <td style="padding:8px 6px;text-align:center;">
              <input *ngIf="u.tipo === 'CANDIDATO' && u.correo" type="checkbox"
                     [checked]="isSelected(u)"
                     (change)="toggleSelect(u)"
                     style="cursor:pointer;accent-color:#1d4ed8;width:14px;height:14px;">
            </td>

            <!-- Tipo -->
            <td style="padding:8px 10px;">
              <span [style.background]="u.tipo === 'CANDIDATO' ? '#eff6ff' : '#f0fdf4'"
                    [style.color]="u.tipo === 'CANDIDATO' ? '#1d4ed8' : '#15803d'"
                    style="padding:2px 7px;border-radius:20px;font-size:10px;font-weight:700;white-space:nowrap;">
                {{ u.tipo === 'CANDIDATO' ? 'Candidato' : 'Empresa' }}
              </span>
            </td>

            <!-- Nombre + Correo combinados -->
            <td style="padding:8px 10px;max-width:220px;">
              <div style="font-weight:600;color:#1e293b;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                <span *ngIf="u.duplicado"
                      style="background:#dc2626;color:#fff;font-size:9px;font-weight:800;padding:1px 4px;border-radius:3px;margin-right:4px;letter-spacing:.5px;vertical-align:middle;">DUP</span>
                {{ u.nombre || '—' }}
              </div>
              <div style="color:#94a3b8;font-size:11px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-top:1px;">
                {{ u.correo }}
              </div>
            </td>

            <!-- Auth provider -->
            <td style="padding:8px 10px;white-space:nowrap;">
              <span [style.color]="providerColor(u.authProvider)"
                    style="font-size:11px;font-weight:600;display:inline-flex;align-items:center;gap:3px;">
                <svg *ngIf="u.authProvider === 'google'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width:12px;height:12px;flex-shrink:0;" fill="currentColor">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
                <svg *ngIf="u.authProvider === 'linkedin'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width:12px;height:12px;flex-shrink:0;" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                {{ providerLabel(u.authProvider) }}
              </span>
            </td>

            <!-- Plan / Suscripción -->
            <td style="padding:8px 10px;text-align:center;white-space:nowrap;">
              <span *ngIf="u.tipo === 'CANDIDATO'"
                    [style.background]="u.subscriptionStatus === 'PREMIUM' ? '#fef3c7' : u.subscriptionStatus === 'CANCELANDO' ? '#fffbeb' : u.subscriptionStatus === 'PAST_DUE' ? '#fef2f2' : '#f1f5f9'"
                    [style.color]="u.subscriptionStatus === 'PREMIUM' ? '#92400e' : u.subscriptionStatus === 'CANCELANDO' ? '#d97706' : u.subscriptionStatus === 'PAST_DUE' ? '#dc2626' : '#64748b'"
                    style="padding:2px 6px;border-radius:20px;font-size:10px;font-weight:600;">
                {{ u.subscriptionStatus === 'CANCELANDO' ? 'Premium (cancel)' : (u.subscriptionStatus || 'FREE') }}
              </span>
              <!-- Plan type badge -->
              <span *ngIf="u.subscriptionPlan && (u.subscriptionStatus === 'PREMIUM' || u.subscriptionStatus === 'CANCELANDO')"
                    [style.background]="u.subscriptionPlan === 'ANUAL' ? '#dbeafe' : '#f0fdf4'"
                    [style.color]="u.subscriptionPlan === 'ANUAL' ? '#1e40af' : '#065f46'"
                    style="padding:1px 5px;border-radius:10px;font-size:9px;font-weight:700;margin-left:3px;display:inline-block;">
                {{ u.subscriptionPlan === 'ANUAL' ? 'Anual' : 'Mensual' }}
              </span>
              <!-- Vigencia -->
              <div *ngIf="u.subscriptionPeriodEnd && (u.subscriptionStatus === 'PREMIUM' || u.subscriptionStatus === 'CANCELANDO')"
                   style="font-size:9px;color:#94a3b8;margin-top:1px;">
                vence {{ u.subscriptionPeriodEnd | appDate:'dd/MM/yy' }}
              </div>
              <span *ngIf="u.tipo === 'EMPRESA'" style="color:#cbd5e1;font-size:11px;">—</span>
            </td>

            <!-- Fecha registro -->
            <td style="padding:8px 10px;color:#94a3b8;font-size:11px;white-space:nowrap;">
              {{ u.createdAt ? (u.createdAt | appDate:'dd/MM/yy') : '—' }}
            </td>

            <!-- Estado + Verificado -->
            <td style="padding:8px 10px;text-align:center;white-space:nowrap;">
              <span [style.background]="u.activo ? '#dcfce7' : '#fee2e2'"
                    [style.color]="u.activo ? '#15803d' : '#dc2626'"
                    style="padding:2px 7px;border-radius:20px;font-size:10px;font-weight:700;display:inline-flex;align-items:center;gap:3px;">
                <svg *ngIf="u.verificado" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" style="width:10px;height:10px;flex-shrink:0;">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                </svg>
                {{ u.activo ? 'Activo' : 'Bloqueado' }}
              </span>
            </td>

            <!-- Usos IA: GuruMatch + CvOptimizer + Freebie -->
            <td style="padding:8px 10px;text-align:center;">
              <ng-container *ngIf="u.tipo === 'CANDIDATO'; else noUsos">
                <div style="display:inline-flex;flex-direction:column;gap:3px;align-items:center;">
                  <!-- Freebie badge -->
                  <span *ngIf="u.freebieUsado"
                        style="background:#d1fae5;color:#065f46;padding:1px 7px;border-radius:10px;font-size:9px;font-weight:700;white-space:nowrap;display:inline-flex;align-items:center;gap:3px;">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" style="width:9px;height:9px;">
                      <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
                    </svg>
                    Freebie usado
                  </span>
                  <span *ngIf="!u.freebieUsado"
                        style="background:#f1f5f9;color:#94a3b8;padding:1px 7px;border-radius:10px;font-size:9px;font-weight:600;white-space:nowrap;">
                    Freebie —
                  </span>
                  <!-- GM + CV counts -->
                  <span style="font-size:10px;color:#64748b;line-height:1;">
                    <span [title]="(u.guruMatchUsageDates?.length ?? 0) > 0 ? 'Usos: ' + u.guruMatchUsageDates!.join(', ') : 'Sin usos'"
                          style="cursor:default;border-bottom:1px dotted #cbd5e1;">
                      <span style="font-weight:700;color:#1d4ed8;">GM</span>
                      <span [style.color]="(u.guruMatchUsos ?? 0) > 0 ? '#1d4ed8' : '#94a3b8'"
                            style="margin-left:3px;font-weight:700;">{{ u.guruMatchUsos ?? 0 }}</span>
                    </span>
                    &nbsp;·&nbsp;
                    <span style="font-weight:700;color:#15803d;">CV</span>
                    <span [style.color]="(u.cvOptimizerUsos ?? 0) > 0 ? '#15803d' : '#94a3b8'"
                          style="margin-left:3px;font-weight:700;">{{ u.cvOptimizerUsos ?? 0 }}</span>
                  </span>
                </div>
              </ng-container>
              <ng-template #noUsos><span style="color:#e2e8f0;font-size:11px;">—</span></ng-template>
            </td>

            <!-- Acciones -->
            <td style="padding:8px 10px;white-space:nowrap;">
              <button (click)="toggle(u)"
                      [disabled]="procesando.has(u.tipo + '-' + u.id)"
                      [style.background]="u.activo ? '#fef3c7' : '#d1fae5'"
                      [style.color]="u.activo ? '#92400e' : '#065f46'"
                      style="border:none;border-radius:5px;padding:3px 8px;font-size:11px;font-weight:600;cursor:pointer;margin-right:3px;">
                {{ u.activo ? 'Bloquear' : 'Activar' }}
              </button>
              <button *ngIf="u.tipo === 'CANDIDATO'" (click)="resetUsos(u)"
                      [disabled]="resetandoUsos.has(u.id)"
                      title="Reiniciar usos GuruMatch y CV Optimizer"
                      style="background:#eff6ff;color:#1d4ed8;border:none;border-radius:5px;padding:3px 7px;font-size:11px;font-weight:600;cursor:pointer;margin-right:3px;">
                {{ resetandoUsos.has(u.id) ? '…' : '↺ Usos' }}
              </button>
              <button (click)="pedirEliminar(u)"
                      style="background:#fee2e2;color:#dc2626;border:none;border-radius:5px;padding:3px 8px;font-size:11px;font-weight:600;cursor:pointer;">
                Eliminar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div style="display:flex;align-items:center;justify-content:space-between;margin-top:16px;">
      <span style="color:#64748b;font-size:13px;">
        {{ page * size + 1 }}–{{ page * size + usuarios.length }} de {{ total }}
      </span>
      <div style="display:flex;gap:8px;">
        <button (click)="prevPage()" [disabled]="page === 0"
                style="background:#f1f5f9;border:1px solid #e2e8f0;border-radius:6px;padding:6px 14px;font-size:12px;cursor:pointer;"
                [style.opacity]="page === 0 ? '0.4' : '1'">Anterior</button>
        <span style="padding:6px 12px;font-size:12px;color:#475569;">{{ page + 1 }} / {{ totalPages || 1 }}</span>
        <button (click)="nextPage()" [disabled]="page >= totalPages - 1"
                style="background:#f1f5f9;border:1px solid #e2e8f0;border-radius:6px;padding:6px 14px;font-size:12px;cursor:pointer;"
                [style.opacity]="page >= totalPages - 1 ? '0.4' : '1'">Siguiente</button>
      </div>
    </div>

    <p *ngIf="usuarios.length === 0" style="text-align:center;color:#94a3b8;padding:40px 0;font-size:14px;">
      No se encontraron usuarios con los filtros aplicados.
    </p>
  </div>
</div>

<!-- ── Confirm Delete Modal ──────────────────────────────────────────────── -->
<div *ngIf="confirmarEliminar"
     style="position:fixed;inset:0;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:9999;">
  <div style="background:#fff;border-radius:12px;padding:28px 32px;max-width:460px;width:90%;box-shadow:0 20px 60px rgba(0,0,0,.2);max-height:90vh;overflow-y:auto;">

    <ng-container *ngIf="!infoDelete">
      <!-- Paso 1: Confirmación inicial -->
      <h3 style="margin:0 0 12px;color:#1e293b;font-size:17px;">¿Eliminar usuario?</h3>
      <p style="color:#475569;font-size:14px;margin:0 0 6px;">
        Esta acción es <strong>permanente</strong> y eliminará todos los datos asociados.
      </p>
      <p style="color:#dc2626;font-size:13px;background:#fee2e2;padding:8px 12px;border-radius:6px;margin:12px 0 8px;">
        {{ confirmarEliminar.nombre || confirmarEliminar.correo }} ({{ confirmarEliminar.tipo }})
      </p>
      <div *ngIf="errorDelete" style="color:#dc2626;font-size:12px;background:#fef2f2;padding:8px 12px;border-radius:6px;margin-bottom:12px;">
        {{ errorDelete }}
      </div>
    </ng-container>

    <ng-container *ngIf="infoDelete">
      <!-- Paso 2: Hay registros relacionados — pedir confirmación forzada -->
      <h3 style="margin:0 0 12px;color:#d97706;font-size:17px;">⚠️ Registros relacionados</h3>
      <p style="color:#475569;font-size:14px;margin:0 0 12px;">
        {{ infoDelete.mensaje }}
      </p>
      <ul style="color:#475569;font-size:13px;padding-left:18px;margin:0 0 16px;">
        <li *ngFor="let d of infoDelete.detalle">{{ d }}</li>
      </ul>
      <p style="color:#dc2626;font-size:13px;font-weight:600;margin:0 0 20px;">
        ¿Deseas eliminar al usuario y TODOS sus registros relacionados?
      </p>
    </ng-container>

    <div style="display:flex;gap:10px;justify-content:flex-end;flex-wrap:wrap;">
      <button (click)="cancelarEliminar()"
              style="background:#f1f5f9;border:1px solid #e2e8f0;border-radius:8px;padding:8px 18px;font-size:13px;cursor:pointer;">
        Cancelar
      </button>
      <button (click)="confirmarBorrar()"
              [disabled]="procesando.has('del-' + confirmarEliminar.tipo + '-' + confirmarEliminar.id)"
              [style.background]="infoDelete ? '#d97706' : '#dc2626'"
              style="color:#fff;border:none;border-radius:8px;padding:8px 18px;font-size:13px;font-weight:600;cursor:pointer;">
        {{ infoDelete ? 'Eliminar todo' : 'Eliminar' }}
      </button>
    </div>
  </div>
</div>

<!-- ═══ Modal: Enviar Correo ═══════════════════════════════════════════════════ -->
<div *ngIf="showEmailModal"
     style="position:fixed;inset:0;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;z-index:9998;"
     (click)="$event.target === $event.currentTarget && !enviandoCorreo ? cerrarModalCorreo() : null">
  <div style="background:#fff;border-radius:12px;width:90%;max-width:800px;max-height:92vh;box-shadow:0 20px 60px rgba(0,0,0,.25);display:flex;flex-direction:column;overflow:hidden;">

    <!-- Header -->
    <div style="display:flex;align-items:center;justify-content:space-between;padding:16px 24px;border-bottom:1px solid #e2e8f0;background:#f8fafc;flex-shrink:0;">
      <h3 style="margin:0;font-size:17px;color:#1e293b;display:flex;align-items:center;gap:10px;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#1d4ed8" style="width:20px;height:20px;flex-shrink:0;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"/>
        </svg>
        Enviar correo a candidatos
      </h3>
      <button (click)="cerrarModalCorreo()" [disabled]="enviandoCorreo"
              style="background:none;border:none;color:#94a3b8;font-size:22px;cursor:pointer;padding:0;line-height:1;">
        ×
      </button>
    </div>

    <!-- Body — con scroll si el contenido es muy largo -->
    <div style="padding:20px 24px;overflow-y:auto;flex:1;min-height:0;">

      <!-- ── Sin resultado (formulario) o con resultado ────────────────────────── -->
      <ng-container *ngIf="!resultadoEnvio; else panelResultado">

        <!-- Destinatarios -->
        <div style="margin-bottom:16px;">
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;">
            <label style="font-size:13px;font-weight:600;color:#475569;">Destinatarios</label>
            <span style="font-size:12px;color:#64748b;">
              <strong style="color:#1d4ed8;">{{ selectedCount }}</strong> candidato{{ selectedCount !== 1 ? 's' : '' }} seleccionado{{ selectedCount !== 1 ? 's' : '' }}
            </span>
          </div>
          <div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;padding:8px 12px;max-height:80px;overflow-y:auto;">
            <ng-container *ngFor="let c of selectedCandidatos; let i = index">
              <span style="font-size:11px;color:#475569;display:inline-block;margin-right:8px;white-space:nowrap;">
                {{ c.nombre }} <span style="color:#94a3b8;">({{ c.correo }})</span>{{ i < selectedCandidatos.length - 1 ? ',' : '' }}
              </span>
            </ng-container>
          </div>
        </div>

        <!-- Asunto -->
        <div style="margin-bottom:16px;">
          <label style="font-size:13px;font-weight:600;color:#475569;display:block;margin-bottom:4px;">
            Asunto <span style="color:#dc2626;">*</span>
          </label>
          <input [(ngModel)]="emailSubject" placeholder="Ej. Nuevas vacantes tech disponibles esta semana"
                 style="width:100%;box-sizing:border-box;border:1px solid #e2e8f0;border-radius:6px;padding:10px 12px;font-size:13px;color:#1e293b;outline:none;"
                 [style.borderColor]="emailSubject.trim() ? '#e2e8f0' : '#fca5a5'">
        </div>

        <!-- Contenido HTML -->
        <div style="margin-bottom:16px;">
          <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;">
            <label style="font-size:13px;font-weight:600;color:#475569;">
              Contenido <span style="color:#94a3b8;font-weight:400;">(HTML)</span>
            </label>
          </div>
          <textarea [(ngModel)]="emailContent" rows="14"
                    style="width:100%;box-sizing:border-box;border:1px solid #e2e8f0;border-radius:6px;padding:10px 12px;font-size:12px;font-family:'Courier New',monospace;color:#1e293b;resize:vertical;outline:none;line-height:1.5;"
                    placeholder="Escribe el contenido HTML del correo..."></textarea>
          <div style="font-size:10px;color:#94a3b8;margin-top:4px;">
            Puedes usar HTML para dar formato. Las variables como #NOMBRE# no se reemplazan automáticamente — el correo se envía tal cual.
          </div>
        </div>

      </ng-container>

      <!-- ── Panel de resultado ─────────────────────────────────────────────── -->
      <ng-template #panelResultado>
        <div style="text-align:center;padding:20px 0;">

          <!-- Ícono de resultado -->
          <div *ngIf="resultadoEnvio.fallidos === 0"
               style="width:56px;height:56px;border-radius:50%;background:#dcfce7;display:inline-flex;align-items:center;justify-content:center;margin-bottom:16px;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="#16a34a" style="width:28px;height:28px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
            </svg>
          </div>
          <div *ngIf="resultadoEnvio.fallidos > 0 && resultadoEnvio.enviados > 0"
               style="width:56px;height:56px;border-radius:50%;background:#fef3c7;display:inline-flex;align-items:center;justify-content:center;margin-bottom:16px;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#d97706" style="width:28px;height:28px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"/>
            </svg>
          </div>
          <div *ngIf="resultadoEnvio.enviados === 0"
               style="width:56px;height:56px;border-radius:50%;background:#fee2e2;display:inline-flex;align-items:center;justify-content:center;margin-bottom:16px;">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#dc2626" style="width:28px;height:28px;">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
            </svg>
          </div>

          <!-- Texto de resultado -->
          <h4 style="margin:0 0 8px;font-size:16px;color:#1e293b;">
            <ng-container *ngIf="resultadoEnvio.fallidos === 0">¡Todos los correos enviados!</ng-container>
            <ng-container *ngIf="resultadoEnvio.fallidos > 0 && resultadoEnvio.enviados > 0">Envío completado con advertencias</ng-container>
            <ng-container *ngIf="resultadoEnvio.enviados === 0">Error al enviar los correos</ng-container>
          </h4>
          <p style="margin:0 0 20px;font-size:14px;color:#64748b;">
            <strong style="color:#16a34a;">✅ {{ resultadoEnvio.enviados }} enviado{{ resultadoEnvio.enviados !== 1 ? 's' : '' }}</strong>
            <span *ngIf="resultadoEnvio.fallidos > 0"> &nbsp;·&nbsp;
              <strong style="color:#dc2626;">❌ {{ resultadoEnvio.fallidos }} fallido{{ resultadoEnvio.fallidos !== 1 ? 's' : '' }}</strong>
            </span>
          </p>

          <!-- Lista de errores -->
          <div *ngIf="resultadoEnvio.errores.length > 0" style="text-align:left;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:12px 16px;margin-bottom:20px;max-height:160px;overflow-y:auto;">
            <p style="margin:0 0 6px;font-size:12px;font-weight:700;color:#991b1b;">Detalle de errores:</p>
            <ul style="margin:0;padding-left:18px;">
              <li *ngFor="let e of resultadoEnvio.errores" style="font-size:11px;color:#b91c1c;margin-bottom:2px;">{{ e }}</li>
            </ul>
          </div>

          <!-- Botones post-resultado -->
          <div style="display:flex;gap:10px;justify-content:center;flex-wrap:wrap;">
            <button (click)="cerrarModalCorreo()"
                    style="background:#f1f5f9;color:#475569;border:1px solid #e2e8f0;border-radius:8px;padding:9px 20px;font-size:13px;font-weight:600;cursor:pointer;">
              Cerrar
            </button>
          </div>
        </div>
      </ng-template>

    </div>

    <!-- Footer (solo se muestra mientras no hay resultado) -->
    <div *ngIf="!resultadoEnvio" style="padding:14px 24px;border-top:1px solid #e2e8f0;background:#f8fafc;display:flex;justify-content:space-between;align-items:center;flex-shrink:0;flex-wrap:wrap;gap:8px;">
      <span style="font-size:11px;color:#94a3b8;">
        {{ selectedCount }} destinatario{{ selectedCount !== 1 ? 's' : '' }}
      </span>
      <div style="display:flex;gap:10px;">
        <button (click)="cerrarModalCorreo()" [disabled]="enviandoCorreo"
                style="background:#f1f5f9;color:#475569;border:1px solid #e2e8f0;border-radius:8px;padding:8px 18px;font-size:13px;font-weight:600;cursor:pointer;">
          Cancelar
        </button>
        <button (click)="enviarCorreo()"
                [disabled]="enviandoCorreo || !emailSubject.trim() || !emailContent.trim() || selectedCount === 0"
                [style.opacity]="(!emailSubject.trim() || !emailContent.trim() || selectedCount === 0) ? '0.5' : '1'"
                style="display:inline-flex;align-items:center;gap:6px;background:#1d4ed8;color:#fff;border:none;border-radius:8px;padding:8px 22px;font-size:13px;font-weight:600;cursor:pointer;">
          <svg *ngIf="!enviandoCorreo" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:14px;height:14px;">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"/>
          </svg>
          <svg *ngIf="enviandoCorreo" style="width:14px;height:14px;animation:spin 1s linear infinite;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle style="opacity:.25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
            <path style="opacity:.75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
          </svg>
          {{ enviandoCorreo ? 'Enviando…' : 'Enviar ' + selectedCount + ' correo' + (selectedCount !== 1 ? 's' : '') }}
        </button>
      </div>
    </div>

  </div>
</div>

<!-- Spinner animation keyframes -->
<style>
  @keyframes spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
</style>

<!-- ── Success toast ──────────────────────────────────────────────────────── -->
<div *ngIf="mensajeDelete"
     style="position:fixed;bottom:24px;right:24px;background:#059669;color:#fff;padding:12px 20px;border-radius:8px;font-size:14px;font-weight:600;z-index:9999;box-shadow:0 4px 16px rgba(0,0,0,.2);">
  ✓ {{ mensajeDelete }}
</div>
